export enum TableAlign {
  Left,
  Center,
  Right,
}
